import axios from "axios";

export default {
  
    data: () => ({
      pay_type1:'',
      pay_type2:'',
      // add by t
      title_type1:'',
      title_type2:'',
     
    }),
    // add by t
    computed:{
      main(){
        return{
          amount : this.pay_type1.replace(/,/g,'') || 0,
          title: this.title_type1,
        }
      },
      support(){
        return{
          amount : this.pay_type2.replace(/,/g,'') || 0,
          title: this.title_type2,
        }
      },
    },
  
    mounted() {
    this.get_pay_type()
    },
  
    methods:{

      async get_pay_type() {
        this.$store.commit('progress_status', true)
        await axios({
            method: "GET",
            url: "/payment-type",
            headers: {
                token: sessionStorage.getItem("token")
            },
        })
            .then((res) => {
                console.log(res.data)
                for (let i = 0; i < res.data.length; i++) {
                  if (res.data[i].id === '1') {
                    this.pay_type1 = parseInt(res.data[i].amount).toLocaleString()
                    this.title_type1 = res.data[i].title
                    console.log(res.data[i].amount);
                  }
                  else{
                    this.pay_type2 = parseInt(res.data[i].amount).toLocaleString()
                    this.title_type2 = res.data[i].title
                    console.log(res.data[i].amount);

                  }
                  
                }
            })
            .catch((err) => {
                console.log(err);
                if (err.message ===
                    "Network Error") {
                    this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                }
            })
            .finally(() => {
                this.$store.commit('progress_status', false)
            });
    },

    async change_pay_type() {

      if(!this.pay_type1 || !this.pay_type2 || !this.title_type1 || !this.title_type2){
        this.$store.commit('snackbar', { color: 'red', text: 'لطفا تمامی فرم را پر کند.' })
        return
      }
      this.$store.commit('progress_status', true)
      await axios({
          method: "PUT",
          url: "/payment-type",
          headers: {
              token: sessionStorage.getItem("token")
          },
          data:{
            main : this.main,
            support : this.support,
          }
      })
          .then((res) => {
              console.log(res.data)
              this.$store.commit('snackbar', { color: 'green', text: res.data })

          })
          .catch((err) => {
              console.log(err);
              if (err.message ===
                  "Network Error") {
                  this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
              }
          })
          .finally(() => {
              this.$store.commit('progress_status', false)
          });
  },
    }
  };